import script from "./HeroSection.vue?vue&type=script&lang=js&setup=true"
export * from "./HeroSection.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__